import { functions, firestore } from 'firebaseSDK';
import { filterObjToStr } from 'config/propertyFields';
import { onSnapshot } from 'firebase/firestore';
import { makeAutoObservable, reaction } from 'mobx';
import FirebaseCollectionItem from './FirebaseCollectionItem';

class SearchResultsState {
  constructor() {
    makeAutoObservable(this);
  }

  state = [];

  isLoading = false;

  isInitialized = false;

  init({ searchBrowserFilterState }) {
    this.searchBrowserFilterState = searchBrowserFilterState;
    this.updateReaction_ = reaction(
      () => this.searchBrowserFilterState.state,
      () => this.update()
    );
    this.isInitialized = true;
  }

  destroy() {
    this.isInitialized = false;
    this.updateReaction_?.();
    this.onSnapshotDestroy_?.();
  }

  handleRefUpdate(snapshot) {
    const data = snapshot.docs.map(
      (d) =>
        new FirebaseCollectionItem(d.data(), 'properties', d.data().propertyUid)
    );
    this.state = data;
    this.isLoading = false;
  }

  *update() {
    try {
      const filterStr = filterObjToStr(this.searchBrowserFilterState.state);
      console.log('FILTER QUERY', filterStr);
      this.isLoading = true;
      const result = yield functions.property.searchQuery({
        filterString: filterStr,
        offset: 0,
      });
      console.log('SEARCH RESULT', result);
      const propertyUids = result.data?.propertyUids;
      if (propertyUids && propertyUids.length) {
        this.onSnapshotDestroy_?.();
        const collectionRef = firestore.getPropertiesRef(propertyUids);
        this.onSnapshotDestroy_ = onSnapshot(collectionRef, (snapshot) =>
          this.handleRefUpdate(snapshot)
        );
        // const properties = yield api.fb.firestore.getProperties(propertyUids);
        // const propertiesDocs = properties.docs.map((p) => p.data());
        // console.log(propertiesDocs);
        // this.state = propertiesDocs;
        // this.isLoading = false;
      } else {
        console.log('Nothing found');
        this.state = [];
        this.isLoading = false;
      }
    } catch (e) {
      this.isLoading = false;
      console.warn('Failed to search');
      console.error(e);
    }

    console.info('update/finished...');
  }
}

export default SearchResultsState;
